var Component = require("!../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  null,
  /* template */
  require("!!../../../node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-237cdc46\"}!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./ViewDocumentIcon.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/icons/ViewDocumentIcon.vue
// module id = 1460
// module chunks = 159